const Menu =  [
  {
    title: 'Início',
    icon: 'inicio.svg',
    iconFilled: 'inicioFill.svg',
    name: 'Home',
    seletor: 'home',
    perfis: ['administrador', 'atendente'],
  },
  {
    title: 'Pedidos',
    icon: 'pedidos.svg',
    iconFilled: 'pedidosFill.svg',
    name: 'Pedidos',
    badge: 'pedidosAguardando',
    seletor: 'pedidos',
    perfis: ['administrador', 'atendente'],
  },
  {
    title: 'Relatório',
    icon: 'relatorio.svg',
    iconFilled: 'relatorioFill.svg',
    name: 'Relatorio',
    seletor: 'relatorio',
    perfis: ['administrador', 'atendente'],
  },
  {
    title: 'Marketing',
    icon: 'marketing.svg',
    iconFilled: 'marketingFill.svg',
    name: 'Marketing',
    badge: 'promocoesAguardando',
    seletor: 'marketing',
    perfis: ['administrador'],
  },
  {
    title: 'Financeiro',
    icon: 'financeiro.svg',
    iconFilled: 'financeiroFill.svg',
    name: 'Financeiro',
    badge: 'boletosDisponiveis',
    seletor: 'financeiro',
    perfis: ['administrador'],
  },
  {
    title: 'Avaliações',
    icon: 'avaliacoes.svg',
    iconFilled: 'avaliacoesFill.svg',
    name: 'Avaliacoes',
    seletor: 'avaliacoes',
    perfis: ['administrador', 'atendente'],
  },
  {
    title: 'Horário de Funcionamento',
    icon: 'horarioFuncionamento.svg',
    iconFilled: 'horarioFuncionamentoFill.svg',
    name: 'Horario',
    badge: 'agendamentosCount',
    seletor: 'horario',
    perfis: ['administrador', 'atendente'],
  },
  {
    title: 'Taxa de Entrega',
    icon: 'taxaEntrega.svg',
    iconFilled: 'taxaEntregaFill.svg',
    name: 'Entrega',
    seletor: 'entrega',
    perfis: ['administrador', 'atendente'],

  },
  {
    title: 'Formas de Pagamento',
    icon: 'formasPagamento.svg',
    iconFilled: 'formasPagamentoFill.svg',
    name: 'Pagamento',
    seletor: 'pagamento',
    perfis: ['administrador', 'atendente'],

  },
  {
    title: 'Cardápio',
    icon: 'cardapio.svg',
    iconFilled: 'cardapioFill.svg',
    name: 'Cardapio',
    seletor: 'cardapio',
    perfis: ['administrador', 'atendente'],

  },
  {
    title: 'Contrato',
    icon: 'contrato.svg',
    iconFilled: 'contrato.svg',
    click: 'openContrato',
    badge: 'badgeContratoPendente',
    seletor: 'contrato',
    show: 'showContrato',
    perfis: ['administrador', 'atendente'],
  },
  {
    title: 'Notificações',
    icon: 'notificacao.svg',
    iconFilled: 'notificacaoFill.svg',
    name: 'Notificacao',
    badge: 'notificacoesPendentes',
    seletor: 'notificacao',
    perfis: ['administrador', 'atendente'],

  },
  // {
  //   title: 'Termos de Adesão',
  //   icon: 'termosAdesao.svg',
  //   iconFilled: 'termosAdesaoFill.svg',
  //   click: 'openDialogTermoAdesao',
  //   badge: 'badgeTermoAdesao',
  //   seletor: 'termo-adesao',
  // },
  {
    title: 'Configurações',
    icon: 'configuracao.svg',
    iconFilled: 'configuracaoFill.svg',
    name: 'Configuracao',
    seletor: 'configuracoes',
    perfis: ['administrador', 'atendente'],

  },
  {
    title: 'Perguntas Frequentes',
    icon: 'perguntasFrequentes.svg',
    iconFilled: 'perguntasFrequentesFill.svg',
    name: 'perguntasFrequentes',
    seletor: 'perguntas-frequentes',
    perfis: ['administrador', 'atendente'],

  },
  {
    title: 'Compartilhar',
    icon: 'compartilhar.svg',
    iconFilled: 'compartilhar.svg',
    click: 'compartilhar',
    seletor: 'compartilhar',
    perfis: ['administrador', 'atendente'],
  }
];

export default Menu;
